<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M5.8757 8.49994H7.3757V14.1249H5.8757V8.49994ZM10.0007 8.82207C10.439 8.39895 10.9498 8.12494 11.5007 8.12494C13.054 8.12494 14.1257 9.38412 14.1257 10.9374V14.1249H12.6257V10.9374C12.6257 10.2126 12.0381 9.62494 11.3132 9.62494C10.5883 9.62494 10.0007 10.2126 10.0007 10.9374V14.1249H8.50072V8.49994H10.0007V8.82207Z" 
    fill="currentColor" />
    <path d="M5.66382 6.62496C5.66382 7.15619 6.09446 7.58684 6.62569 7.58684C7.15692 7.58684 7.58757 7.15619 7.58757 6.62496C7.58757 6.09373 7.15692 5.66309 6.62569 5.66309C6.09446 5.66309 5.66382 6.09373 5.66382 6.62496Z" 
    fill="currentColor" />
    <path d="M4.75 3.5H15.25C15.9404 3.5 16.5 4.05964 16.5 4.75V15.25C16.5 15.9404 15.9404 16.5 15.25 16.5H4.75098C4.06065 16.5 3.50101 15.9403 3.50098 15.25L3.5 4.75C3.5 4.05968 4.05969 3.50006 4.75 3.5Z" 
    stroke="currentColor" stroke-width="1.5"/>
  </svg>
</template>

<script>
export default {
  name: 'SpyderOverviewIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>